"use strict";
// @ts-ignore
try {
    self['workbox:google-analytics:7.3.0'] && _();
}
catch (e) { }
